// src/pages/FacturasPorCobrar.jsx
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  Timestamp,
  addDoc
} from 'firebase/firestore';

const FacturasPorCobrar = () => {
  const [facturas, setFacturas] = useState([]);

  // Filtros opcionales
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [busquedaCliente, setBusquedaCliente] = useState('');

  useEffect(() => {
    cargarFacturas();
  }, []);

  const cargarFacturas = async () => {
    const snap = await getDocs(collection(db, 'facturasPorCobrar'));
    const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    setFacturas(data);
  };

  // ============================
  // FILTRO FACTURAS
  // ============================
  const facturasFiltradas = facturas.filter(f => {
    // Filtro por cliente (texto)
    if (busquedaCliente.trim() !== '') {
      // Asumiendo f.clienteId representa el nombre/ID del cliente
      const nombreCompleto = (f.clienteId || '').toLowerCase();
      if (!nombreCompleto.includes(busquedaCliente.toLowerCase())) {
        return false;
      }
    }

    // Filtro por rango de fechas (asumiendo f.fecha es un Timestamp)
    if (fechaInicio) {
      const fechaFactura = f.fecha?.toDate ? f.fecha.toDate() : null;
      if (fechaFactura && fechaFactura < new Date(fechaInicio)) {
        return false;
      }
    }
    if (fechaFin) {
      const fechaFactura = f.fecha?.toDate ? f.fecha.toDate() : null;
      if (fechaFactura && fechaFactura > new Date(fechaFin)) {
        return false;
      }
    }

    return true;
  });

  // ============================
  // ABONAR
  // ============================
  const abonarFactura = async (factura) => {
    const abonoStr = prompt('Monto a abonar (USD):');
    const abono = parseFloat(abonoStr);
    if (isNaN(abono) || abono <= 0) {
      alert('Monto inválido');
      return;
    }

    // Nuevo pendiente
    const nuevoPendiente = factura.total - abono;
    let nuevoEstado = 'pendiente';

    if (nuevoPendiente <= 0) {
      // Se paga por completo
      nuevoEstado = 'pagada';
    }

    // Actualizar en facturasPorCobrar
    const facturaRef = doc(db, 'facturasPorCobrar', factura.id);
    await updateDoc(facturaRef, {
      total: nuevoPendiente > 0 ? nuevoPendiente : 0,
      estado: nuevoEstado,
      fechaAbono: Timestamp.now()
    });

    // (OPCIONAL) Crear en 'ventas' si se paga por completo
    if (nuevoEstado === 'pagada') {
      await addDoc(collection(db, 'ventas'), {
        clienteId: factura.clienteId,
        productos: factura.productos,
        fecha: Timestamp.now(),
        estado: 'pagada',
        totalPagado: factura.total, // Lo que era el total original
        origen: 'facturaPorCobrar'
      });
      alert('Factura saldada. Registrada en Ventas');
    }

    alert('Abono realizado correctamente.');
    // recargar
    cargarFacturas();
  };

  return (
    <div className="facturas-por-cobrar-container">
      <h2>Facturas por Cobrar</h2>

      <div className="facturas-filtros">
        <div>
          <label>Fecha inicio:</label><br />
          <input
            type="date"
            value={fechaInicio}
            onChange={e => setFechaInicio(e.target.value)}
          />
        </div>
        <div>
          <label>Fecha fin:</label><br />
          <input
            type="date"
            value={fechaFin}
            onChange={e => setFechaFin(e.target.value)}
          />
        </div>
        <div>
          <label>Buscar cliente:</label><br />
          <input
            type="text"
            placeholder="Cliente ID o Nombre"
            value={busquedaCliente}
            onChange={e => setBusquedaCliente(e.target.value)}
          />
        </div>
      </div>

      {facturasFiltradas.length === 0 ? (
        <p>No hay facturas a crédito pendientes para este filtro.</p>
      ) : (
        <div className="facturas-lista">
          {facturasFiltradas.map((fact) => (
            <div key={fact.id} className="factura-item">
              <p><strong>ID:</strong> {fact.id}</p>
              <p><strong>Estado:</strong> {fact.estado}</p>
              <p><strong>Cliente:</strong> {fact.clienteId}</p>
              <p><strong>Total Pendiente:</strong> ${fact.total?.toFixed(2)}</p>
              <p><strong>Fecha:</strong> {fact.fecha?.toDate().toLocaleString()}</p>
              <p><strong>Productos:</strong></p>
              <ul>
                {fact.productos?.map((p, idx) => (
                  <li key={idx}>
                    {p.nombre} x{p.cantidad}
                  </li>
                ))}
              </ul>

              {fact.estado !== 'pagada' && (
                <button onClick={() => abonarFactura(fact)}>
                  Abonar
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FacturasPorCobrar;
